import { colors, Divider, Stack, Typography } from '@mui/material';

export default function IndexLogoContainer() {

	return (
		<Stack direction="row" paddingX={2} gap={1.5} justifyItems="center" alignItems="center">
      <Typography color="primary" lineHeight={1}>
          <svg fill="none" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" height="36px">
              <mask id="a" fill="white">
                  <rect width="128" height="128" rx="1"/>
              </mask>
              <rect width="128" height="128" rx="1" fill="#fff" mask="url(#a)" stroke="currentColor" strokeWidth="10"/>
              <rect x="3.5" y="3.5" width="121" height="121" rx="12.5" fill="#fff" stroke="currentColor" strokeWidth="7"/>
              <path d="m101.69 38.697c0 5.1953-4.2115 9.4069-9.4068 9.4069s-9.407-4.2116-9.407-9.4069c0-5.1954 4.2117-9.407 9.407-9.407s9.4068 4.2116 9.4068 9.407z" fill="#fff" stroke="currentColor" strokeWidth="5"/>
              <path d="m45.128 94.279c0 5.1954-4.2117 9.407-9.407 9.407s-9.407-4.2116-9.407-9.407c0-5.1953 4.2117-9.4069 9.407-9.4069s9.407 4.2116 9.407 9.4069z" fill="#fff" stroke="currentColor" strokeWidth="5"/>
              <path d="m35.721 86.326c1.1907-38.102 31.256-47.628 46.14-47.628" stroke="currentColor" strokeWidth="5"/>
          </svg>
      </Typography>

			<Divider orientation="vertical" flexItem />

			<Stack direction="column" gap={0}>
				<Typography
					variant="subtitle2"
					color="primary"
					lineHeight={1.2}
					gutterBottom
					fontFamily="Apertura Medium"
					fontWeight={400}
				>
					Spline Data
				</Typography>
				<Typography
					variant="subtitle2"
					fontWeight={400}
					color={colors.grey[900]}
					lineHeight={1}
					fontFamily="Sofia Pro Light"
				>
					Primary
				</Typography>
			</Stack>
		</Stack>
	)
}
